import * as Connector from 'shared/connectors/notificationConnector';
import { NOTIFICATION } from 'store/types';

const init = () => ({
  type: NOTIFICATION.GET_ACTIVE_DAY_NOTIFICATIONS_INIT,
});

export const success = data => ({
  type: NOTIFICATION.GET_ACTIVE_DAY_NOTIFICATIONS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: NOTIFICATION.GET_ACTIVE_DAY_NOTIFICATIONS_FAILURE,
});

const getActiveDayNotifications = (params = null) => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getActiveDayNotifications(params);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getActiveDayNotifications;
